import { memo, SyntheticEvent } from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import MUISwitch from '@mui/material/Switch';

interface SwitchProps {
  name: string;
  checked?: boolean;
  onChange: (event: SyntheticEvent<Element, Event>, checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

export const Switch = memo<SwitchProps>(({ name, checked, onChange, label, disabled }) => (
  <FormControlLabel
    name={name}
    control={<MUISwitch checked={checked} color="secondary" disabled={disabled} />}
    onChange={onChange}
    label={label}
    disabled={disabled}
  />
));

Switch.displayName = 'Switch';
